/**
 * The phone app's words for the employee's own expense reports (piece 35, *The
 * fourth release*; decisions 4640, 4641 and 5200; row T2458), spread into the
 * one string lookup beside the earlier batches' words. A word the web's expense
 * pages already say, such as Expenses, Submit, Category, Miles, Attendees or
 * Business Purpose, is read from the web's own key and is not repeated here.
 */
export const EXPENSE_PHONE_STRINGS = {
  'mobile.expenses.lines': 'Lines',
  'mobile.expenses.addLine': '+ Add Line',
  'mobile.expenses.lineTitle': 'Add Line',
  'mobile.expenses.lineSave': 'Add',
  'mobile.expenses.scanReceipt': 'Scan Receipt',
  'mobile.expenses.receiptAttached': 'The receipt is attached to this line.',
  'mobile.expenses.retakeReceipt': 'Take It Again',
  'mobile.expenses.noReceiptYet': 'No receipt yet. A category that asks for one keeps the report from being submitted until the line has its receipt scanned.',
  'mobile.expenses.receiptPdf': 'PDF',
  'mobile.expenses.receiptHeld': 'Being checked',
  'mobile.expenses.submitAsk': 'Submit expense report',
  'mobile.expenses.submitBody': 'It goes to its approver, and its lines then read only here and on the web.',
  'mobile.expenses.submittedReadOnly': 'This report is submitted, so it reads only until its approver decides it.',
  // Decision 9300, row T3130: another person's report opened for the viewer's decision.
  'mobile.expenses.filedBy': 'Filed by',
  'mobile.expenses.rejectBody': 'The report goes back to Draft with your reason, and the person who filed it can change it and submit it again.',
  'mobile.expenses.approvedStep': 'Your approval is recorded. The report waits for the next approver.',
  'mobile.expenses.decideNeedsSignal': 'Approve and Reject need a signal. Neither is saved on this phone to send later.',
  'mobile.expenses.newReportSave': 'Start',
  'mobile.expenses.newReportHint': 'The period opens on this calendar month; change either day for another.',
  'mobile.expenses.made': 'The report was made.',
  'mobile.expenses.mileageAbout': 'which makes about',
  'mobile.expenses.mealHint': 'A meal names its place, its purpose and who was there by name, because the tax code asks for all three.',
  'mobile.expenses.findAttendee': 'Find a person by name',
  'mobile.expenses.noAttendee': 'Nobody is named yet.',
  'mobile.expenses.problem.day': 'Enter the day the money was spent, as year, month and day.',
  'mobile.expenses.problem.category': 'Choose the category the expense belongs to.',
  'mobile.expenses.problem.description': 'Say what the expense was for.',
  'mobile.expenses.problem.amount': 'Enter the amount that was spent.',
  'mobile.expenses.problem.miles': 'Enter the miles driven.',
  'mobile.expenses.problem.period': 'Enter the period’s first and last day, the first no later than the last.',
  'mobile.expenses.problem.uploading': 'Wait for the receipt to finish uploading.',
  // Decision 5320, row T2711: the line and its receipt queued with no signal, and Submit held behind a line still waiting.
  'mobile.expenses.lineUnsent': 'The line was not added, because the server did not answer. Check the connection, then press Add again.',
  'mobile.expenses.lineQueued': 'The line is saved on this phone. It is added to the report when the phone has a signal, and the clock in the header shows it until then.',
  'mobile.expenses.receiptQueued': 'The receipt is saved on this phone. It is sent before the line when the phone has a signal.',
  // T2711's review: a queued receipt that failed, or left the phone with no File id heard, while the line form was open.
  'mobile.expenses.receiptFailed': 'The receipt was not saved, so this line cannot name it. Take it again, or add the line without it where its category asks for none.',
  'mobile.expenses.receiptMissing': 'The receipt has left this phone, but the server did not say which file it became, so this line cannot name it. Take it again.',
  'mobile.expenses.typesLoading': 'The receipt types are still loading. Try again in a moment.',
  'mobile.expenses.submitWaits': 'A line on this report is still waiting to sync. Submit once it has gone.',
  // Decision 7770, row T3127: the Expenses side of the switch, its chips, its + sheet and Add to Report.
  'mobile.expenses.chipAll': 'All',
  'mobile.expenses.addTitle': 'Add an Expense',
  'mobile.expenses.noneYet': 'You have no expenses yet.',
  'mobile.expenses.noneForChip': 'None of your expenses has this status.',
  'mobile.expenses.expenseUnsent': 'The expense was not saved, because the server did not answer. Check the connection, then press Save again.',
  // Decision 7771, row T3128: the receipt-first form, its reading with no signal, and the job it is for.
  'mobile.expenses.receiptQueuedRead': 'The receipt is saved on this phone and is read once the phone has a signal. Save with the fields left empty and the expense waits under Unreported for your review, or type them now.',
  'mobile.expenses.expenseQueued': 'The expense is saved on this phone. It is sent when the phone has a signal, and the clock in the header shows it until then.',
  'mobile.expenses.pendingReview': 'Waiting to sync, then for your review',
  'mobile.expenses.projectKind': 'Deal or Work Order',
  'mobile.expenses.findProject': 'Find a job by its name or number',
  // Decision 7920, row T3129: the Mileage entry, its odometer pair and the drive the phone measures.
  'mobile.mileage.odometerStart': 'Odometer Start',
  'mobile.mileage.odometerEnd': 'Odometer End',
  'mobile.mileage.odometerHint': 'Give both readings and the miles are their difference.',
  'mobile.mileage.fromOdometer': 'From the odometer: the difference of the two readings.',
  'mobile.mileage.fromDrive': 'From the drive; change the miles if the reading fell short.',
  'mobile.mileage.startDrive': 'Start Drive',
  'mobile.mileage.stopDrive': 'Stop Drive',
  'mobile.mileage.driveHint': 'Start Drive measures the drive while this page stays open. Only the miles are kept, never the way you went.',
  'mobile.mileage.driveStarted': 'Drive started at',
  'mobile.mileage.soFar': 'so far',
  'mobile.mileage.driveDenied': 'Location access was refused, so the drive is not measured. Type the miles instead.',
  'mobile.mileage.driveFailed': 'The drive could not be measured.',
  'mobile.mileage.eventsUnread': 'The calendar is read with a signal. Type To and Purpose instead.',
  'mobile.mileage.mapReading': 'The map is measuring the drive.',
  'mobile.mileage.problem.reading': 'Enter an odometer reading as a number of miles.',
  'mobile.mileage.problem.odometer': 'Odometer End reads above Odometer Start.',
  'mobile.mileage.problem.purpose': 'Say why the drive was made.',
  'mobile.mileage.queued': 'The drive is saved on this phone. It is sent when the phone has a signal, and the clock in the header shows it until then.',
  'mobile.mileage.unsent': 'The drive was not saved, because the server did not answer. Check the connection, then press Save again.',
  // Decision 7920, row T3129: Per Diem, a daily allowance at a rate from the table.
  'mobile.perDiem.title': 'Per Diem',
  'mobile.perDiem.subtitle': 'A daily allowance for days away, at a rate the office set.',
  'mobile.perDiem.firstDay': 'First Day',
  'mobile.perDiem.lastDay': 'Last Day',
  'mobile.perDiem.rate': 'Rate',
  'mobile.perDiem.days': 'days',
  'mobile.perDiem.day': 'day',
  'mobile.perDiem.daysLabel': 'Days',
  'mobile.perDiem.daysHint': 'The days the two dates span; type fewer, or a half day, where you claim less.',
  'mobile.perDiem.at': 'at',
  'mobile.perDiem.aDayMakes': 'a day, which makes about',
  'mobile.perDiem.noRate': 'No per diem rate is in force on the first day, so none can be claimed yet. Ask whoever keeps the rates for one.',
  'mobile.perDiem.problem.lastDay': 'The last day falls on or after the first day.',
  'mobile.perDiem.problem.rate': 'Choose the rate the days are claimed at.',
  'mobile.perDiem.problem.days': 'Enter the days in whole or half days, no more than the dates span.',
  'mobile.perDiem.problem.purpose': 'Say why the travel was made.',
  'mobile.perDiem.saved': 'The per diem was saved as unreported; it goes on a report when you add it to one.',
  'mobile.perDiem.queued': 'The per diem is saved on this phone. It is sent when the phone has a signal, and the clock in the header shows it until then.',
  // Decision 7920, row T3129: Trips, grouping one journey's expenses.
  'mobile.trip.new': 'New Trip',
  'mobile.trip.newSubtitle': 'Group one journey’s expenses under its name.',
  'mobile.trip.name': 'Trip Name',
  'mobile.trip.startedOn': 'Start Day',
  'mobile.trip.purpose': 'Purpose',
  'mobile.trip.hint': 'The trip groups the expenses you add to it on this list. They go on reports as you put them there, never all at once.',
  'mobile.trip.addTo': 'Add to',
  'mobile.trip.end': 'End Trip',
  'mobile.trip.endAsk': 'End this trip?',
  'mobile.trip.endBody': 'New expenses are no longer offered it. The expenses on it stay grouped under it.',
  'mobile.trip.since': 'Open since',
  'mobile.trip.ended': 'Ended',
  'mobile.trip.started': 'The trip is open. Each new expense offers it.',
  'mobile.trip.endedNotice': 'The trip has ended.',
  'mobile.trip.problem.name': 'Name the trip.',
  'mobile.perDiem.unsent': 'The per diem was not saved, because the server did not answer. Check the connection, then press Save again.',
} as const;
